import { Spin } from 'antd';
import { useStore } from '../store/store';
import { RESTORE_LOCK_ID } from './lockIds';

// Overlay plein écran pendant une restauration de version — la sienne
// (isRestoringVersion) ou celle d'un co-éditeur (verrou partagé
// reserved:restore). Le content entier est en train d'être remplacé : toute
// interaction souris est bloquée, aucune sélection/édition possible.
// Complété par les gels logiques (editFreezeHolder, undo) pour le clavier.
export const RestoreOverlay = () => {
  const label = useStore(({ boxLocks, user, isRestoringVersion }) => {
    if (isRestoringVersion) return 'Restauration de la version en cours…';
    const lock = boxLocks[RESTORE_LOCK_ID];
    if (lock && lock.id !== user?.id) return `${lock.name} restaure une version…`;
    return null;
  });

  if (!label) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        // Au-dessus des drawers/modals antd (~1000) et des bannières collab (2000)
        zIndex: 2100,
        backgroundColor: 'rgba(255, 255, 255, 0.65)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
      }}
    >
      <Spin size='large' />
      <span style={{ fontWeight: 600, color: '#333' }}>{label}</span>
    </div>
  );
};

export default RestoreOverlay;
